var _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRenaultNet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 17,
    viewBox: "0 0 94 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    fontFamily: "NouvelR-Bold, NouvelR",
    fontSize: 16,
    fontWeight: "bold",
    fillOpacity: 0.85
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 14
  }, "Renault.net"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenaultNet);
export default __webpack_public_path__ + "static/media/renault-net.ac4e71e8fd8c58b123580e21d934282e.svg";
export { ForwardRef as ReactComponent };